const lbaDate = angular.module('app.lbaDate', []);

lbaDate.controller('lbaDateCtrl', require('./lbaDateCtrl'));
lbaDate.directive('lbaDate', require('./lbaDateDir'));

export default lbaDate;



// WEBPACK FOOTER //
// ./src/components/lbaDate/index.js